const tagWizard = {
    currentScreen: 'UsageScreen',
    isLoading: false,
    selectedProduct: null,
    selectedAddOns: {},
    selectedMMT: null,
    selectedMMTTagLayout: null,
    selectedMMTF: null,
    selectedMMTFTagLayout: null,
    selectedMaleButtons: {},
    selectedIncludedItem: null,
    products: {},
    lineItemProducts: [],
    userInput: {
        cartQty: 1,
        tagType: null,
        printingMethod: '', // Laser by default
        markingVariation: null,
        DiseaseCode: '',
        StartingNumber: '',
        ContinueSequence: 1,
        UsePrefix: 0,
        Prefix: '',
        Suffix: '',
        IncludeMMT: 0,
        DAFAuthorisationNumber: '',
        DAFAuthorisationCheckbox: 0,
    },
    PICVerified: false,
    propertyValidated: false,
    propertyState: '',
    lastSequenceNumber: null,
    availableProcessedLayouts: {},
    availablePICNumbers: {},
    includedItems: {},
    maleButtonTags: {},
    matchingManagementTags: {},
    relatedTags: {},
    relatedProductList: {},
    disallowedNLISStates: ['VIC'],
    errors: {
        NAITCustomList: null,
    },
};

/**
 * This shows what keys will be saved on JSON state during tag wizard export
 * @type {*[]}
 */
export const exportedkeys = [
    'currentScreen',
    'selectedProduct',
    'selectedAddons',
    'selectedMMT',
    'selectedMMTTagLayout',
    'selectedMMTF',
    'selectedMMTFTagLayout',    
    'selectedMaleButtons',
    'selectedIncludedItem',
    'userInput',
    'PICVerified',
    'propertyValidated',
    'propertyState',
    'lastSequenceNumber',
    'includedItems',
    'disallowedNLISStates',
    'matchingManagementTags',
    'availableProcessedLayouts',
];

const TagWizardReducer = function(state = tagWizard, action) {
    switch (action.type) {
        case 'TOGGLE_TAG_WIZARD_LOADING': {
            return {
                ...state,
                isLoading: action.value,
            };
        }
        case 'TAG_WIZARD_SET_DATA': {
            return {
                ...state,
                ...action.data,
            };
        }
        case 'TAG_WIZARD_SET_ERROR': {
            return {
                ...state,
                errors: {
                    [action.key]: action.value,
                },
            };
        }
        case 'TAG_WIZARD_CHANGE_SCREEN': {
            return {
                ...state,
                currentScreen: action.value,
            };
        }
        case 'TAG_WIZARD_SELECT_PRODUCT': {
            return {
                ...state,
                selectedProduct: action.value,
            };
        }
        case 'TAG_WIZARD_SET_PRODUCT_ADDON': {
            return {
                ...state,
                selectedAddOns: action.list,
            };
        }
        case 'TAG_WIZARD_UPDATE_PRODUCT_ADDON': {
            let newList = { ...state.selectedAddOns };

            Object.entries(action.list).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                selectedAddOns: {
                    ...state.selectedAddOns,
                    ...action.value,
                },
            };
        }
        case 'TAG_WIZARD_SET_PIC_VALIDATION': {
            return {
                ...state,
                PICVerified: action.value,
            };
        }
        case 'TAG_WIZARD_SET_PROPERTY_VALIDATION': {
            return {
                ...state,
                propertyValidated: action.value,
            };
        }
        case 'TAG_WIZARD_SET_PROPERTY_STATE': {
            return {
                ...state,
                propertyState: action.value,
            };
        }
        case 'TAG_WIZARD_SET_LAST_SEQUENCE_NUMBER': {
            return {
                ...state,
                lastSequenceNumber: action.value,
            };
        }
        case 'TAG_WIZARD_SET_PRODUCTS': {
            return {
                ...state,
                products: action.list,
            };
        }
        case 'TAG_WIZARD_UPDATE_PRODUCTS': {
            let newList = { ...state.products };

            Object.entries(action.list).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                products: newList,
            };
        }
        case 'TAG_WIZARD_UPDATE_LINE_ITEMS_PRODUCTS': {
            return {
                ...state,
                lineItemProducts: action.list,
            };
        }
        case 'TAG_WIZARD_UPDATE_PIC_NUMBERS': {
            let newList = { ...state.availablePICNumbers };

            Object.entries(action.list).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                availablePICNumbers: newList,
            };
        }
        case 'TAG_WIZARD_SET_USER_INPUT': {
            return {
                ...state,
                userInput: {
                    ...state.userInput,
                    [action.key]: action.value,
                },
            };
        }
        case 'TAG_WIZARD_UPDATE_MATCHING_MANAGEMENT_TAG_LIST': {
            let newList = { ...state.matchingManagementTags };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                matchingManagementTags: newList,
            };
        }
        case 'TAG_WIZARD_SELECT_MATCHING_MANAGEMENT_TAG': {
            return {
                ...state,
                selectedMMT: action.value
            };
        }
        case 'TAG_WIZARD_SELECT_MATCHING_MANAGEMENT_FEMALE_TAG': {
            return {
                ...state,
                selectedMMTF: action.value
            };
        }
        case 'TAG_WIZARD_SELECT_INCLUDED_ITEM_TAG': {
            const includedItems = state.includedItems;
            return {
                ...state,
                selectedIncludedItem: includedItems[action.value],
            };
        }
        case 'TAG_WIZARD_SET_MMT_LAYOUT': {
            return {
                ...state,
                selectedMMTTagLayout: action.value,
            };
        }
        case 'TAG_WIZARD_SET_MMTF_LAYOUT': {
            return {
                ...state,
                selectedMMTFTagLayout: action.value,
            };
        }        
        case 'TAG_WIZARD_SET_MMTF_LAYOUT': {
            return {
                ...state,
                selectedMMTFTagLayout: action.value,
            };
        }    
        case 'TAG_WIZARD_SET_MMTF_LAYOUT': {
            return {
                ...state,
                selectedMMTFTagLayout: action.value,
            };
        }        
        case 'TAG_WIZARD_UPDATE_MALE_BUTTON_TAG_LIST': {
            let newList = { ...state.maleButtonTags };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                maleButtonTags: newList,
            };
        }
        case 'TAG_WIZARD_SELECT_MALE_BUTTON': {
            let newSelectedMaleButtons = {...state.selectedMaleButtons};

            if(action.value === false) {
                delete newSelectedMaleButtons[action.key];
            }
            else {
                newSelectedMaleButtons[action.key] = true;
            }

            return {
                ...state,
                selectedMaleButtons: newSelectedMaleButtons
            };
        }
        case 'TAG_WIZARD_SELECT_INCLUDED_ITEM': {
            let newSelectedIncludedItems = {...state.includedItems};

            return {
                ...state,
                includedItems: action.value,
            };
        }
        case 'TAG_WIZARD_UPDATE_INCLUDED_ITEM_TAG_LIST': {
            let newList = { ...state.includedItems };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                includedItems: newList,
            };
        }
        case 'TAG_WIZARD_UPDATE_RELATED_TAG_LIST': {
            let newList = { ...state.relatedTags };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                relatedTags: newList,
            };
        }
        case 'TAG_WIZARD_UPDATE_RELATED_PRODUCT_LIST': {
            let newList = { ...state.relatedProductList };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                relatedProductList: newList,
            };
        }
        case 'TAG_WIZARD_SET_AVAILABLE_LAYOUTS': {
            return {
                ...state,
                availableProcessedLayouts: {
                    ...state.availableProcessedLayouts,
                    [action.key]: action.list,
                },
            };
        }
        case 'TAG_WIZARD_RESET': {
            return {
                ...state,
                userInput: tagWizard.userInput,
                selectedAddOns: {},
                selectedMMT: null,
                selectedMMTTagLayout: null,
                selectedMMTF: null,
                selectedMMTFTagLayout: null,                
                selectedMaleButtons: {},
                selectedIncludedItem: null,
                PICVerified: false,
                propertyValidated: false,
                propertyState: '',
                lastSequenceNumber: null,
            }
        };
        default: {
            return state;
        }
    }
};

export default TagWizardReducer;
